import React from 'react';

const PackageSummary = ({ summary }) => {
  return (
    <div 
      className="package-details-section" 
      style={{
        textAlign: 'right', 
        display: 'flex', 
        alignItems: 'flex-start', 
        justifyContent: 'flex-end', 
        gap: '10px'
      }}
    >
      <div style={{marginTop: '5px', fontSize: '10px', fontWeight: '700'}}>
        TOTAL
      </div>
      <table className="package-summary">
        <thead>
          <tr>
            <th>PACKAGE</th>
            <th>N.W</th>
            <th>G.W</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{summary.totalCartons}</td>
            <td>{summary.netWeight} kg</td>
            <td>{summary.grossWeight} kg</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PackageSummary;